<h1 class="title">Privacy</h1>
<h5>&nbsp;</h5>

<p>Codify Asset Solutions Limited (CAS) (we, us, our) complies with the New Zealand Privacy Act 1993 (the Act) when dealing
    with personal information. Personal information is information about an identifiable individual (a natural person),
    and includes personal data, personally identifiable information and equivalent information under applicable privacy and
    data protection laws. This policy does not limit or exclude any of your rights under the Act.
    For further information on the Act, see www.privacy.org.nz.</p>

<p>Our <a href="assets/documents/privacy_policy.pdf">Privacy Policy</a> (accessible on the footer of every page throughout ACABIM)
    has been drafted with brevity and clarity in mind. It does not provide exhaustive detail of all aspects of our collection and use of
    personal information. We are happy to provide any additional information or explanation needed. Any request for further
    information should be sent to privacy.officer@cas.net.nz</p>

<p>By registering to use ACABIM, you are bound by our <a href="assets/documents/termsOfUse.pdf">Terms and Conditions of Use</a>.</p>

<p>If you have any other concerns, please contact us at enquiry@cas.net.nz</p>
